export const serverUrls = {
  authUrl: process.env.VUE_APP_API_URL_BACKEND,
};

export const keycloakEnv = {
  url: process.env.VUE_APP_KEYCLOAK_URL,
  realm: process.env.VUE_APP_KEYCLOAK_REALM,
  clientId: process.env.VUE_APP_KEYCLOAK_CLIENT_ID,
};

export const IptcEnum = {
  ACE: 'ACE',
  CLJ: 'CLJ',
  DIS: 'DIS',
  EBF: 'EBF',
  EDU: 'EDU',
  ENV: 'ENV',
  HTH: 'HTH',
  HUM: 'HUM',
  LAB: 'LAB',
  LIF: 'LIF',
  POL: 'POL',
  REL: 'REL',
  SCI: 'SCI',
  SOI: 'SOI',
  SPO: 'SPO',
  WAR: 'WAR',
  WEA: 'WEA',
};

export const IptcLabels = {
  [IptcEnum.ACE]: 'Arts, Culture & Entertainment',
  [IptcEnum.CLJ]: 'Crime, Law & Justice',
  [IptcEnum.DIS]: 'Disaster & Accident',
  [IptcEnum.EBF]: 'Economy, Business & Finance',
  [IptcEnum.EDU]: 'Education',
  [IptcEnum.ENV]: 'Environment',
  [IptcEnum.HTH]: 'Health',
  [IptcEnum.HUM]: 'Human Interest',
  [IptcEnum.LAB]: 'Labour',
  [IptcEnum.LIF]: 'Lifestyle & Leisure',
  [IptcEnum.POL]: 'Politics',
  [IptcEnum.REL]: 'Religion & Belief',
  [IptcEnum.SCI]: 'Science & Technology',
  [IptcEnum.SOI]: 'Social Issue',
  [IptcEnum.SPO]: 'Sports',
  [IptcEnum.WAR]: 'Unrest, Conflicts & War',
  [IptcEnum.WEA]: 'Weather',
};

export const IptcArray = Object.entries(IptcLabels).map(([value, label]) => ({
  value,
  label,
}));

export const THUMBNAIL_SIZE = 500;
